import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useMaincategory } from "../../actions/homeActions";
export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const swiperRef = useRef(null);
  const showOnHomePage = true;
  const {
    data: maincategory,
    isLoading,
    isError,
    error,
  } = useMaincategory("main", showOnHomePage);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading main categories: {error.message}
        </p>
      </div>
    );
  }
  const handlemaincategory = (id) => {
    dispatch({
      type: "UPDATE_MAIN_CATEGORY_ID_DATA",
      payload: { maincategoryId: id },
    });
    navigate("/category");
  };
  return { isLoading, swiperRef, maincategory, handlemaincategory };
};
